/** CAROUSELS **/
const featureSplide = document.querySelectorAll(".feature-header");
if (featureSplide.length > 0) {
	featureSplide.forEach(function (sp) {
		new Splide(sp, {
			mediaQuery: "min",
			perPage: 1,
			//autoWidth: true,
			pagination: false,
			type: "normal",
		}).mount();
	});
}

const mindfulMoneySplide = document.querySelectorAll(".mindful-money-block");
if (mindfulMoneySplide.length > 0) {
	mindfulMoneySplide.forEach(function (sp) {
		new Splide(sp, {
			mediaQuery: "min",
			perMove: 1,
			perPage: 1,
			//autoWidth: true,
			pagination: false,
			type: "normal",
			gap: "1em",
			type: "loop",
			focus: "center",
			arrows: true,
			breakpoints: {
				980: {
					destroy: true,
				},
			},
		}).mount();
	});
}

const testimonialBlock = document.querySelectorAll('.testimonial-block.splide');
if (testimonialBlock.length > 0) {
	testimonialBlock.forEach(function (sp) {
		new Splide(sp, {
			perPage: 1,
			//autoWidth: true,
			pagination: false,
			type: "normal",
		}).mount();
	});
}

const blogCategoryBlock = document.querySelectorAll(".category-jump-off.splide, .blog-category-jump-off.splide");
if (blogCategoryBlock.length > 0) {
	blogCategoryBlock.forEach(function (sp) {
		let splide;
		if (sp.classList.contains('card-carousel')) {
			splide = new Splide(sp, {
				mediaQuery: "min",
				perPage: 1,
				//autoWidth: true,
				pagination: false,
				type: "normal",
			})
		} else {
			splide = new Splide(sp, {
				mediaQuery: "min",
				perPage: 1,
				//autoWidth: true,
				pagination: false,
				type: "normal",
				breakpoints: {
					980: {
						destroy: true,
					},
				},
			})
		}

		splide.mount();
	});
}

const partnerCarousel = document.querySelectorAll('.partner-carousel.splide');

for (const carousel of partnerCarousel) {
	new Splide(carousel, {
		//autoWidth: true,
		mediaQuery: "max",
		arrows: true,
		perMove: 1,
		perPage: 1,
		type: "normal",
		pagination: false,
		//focus: 'center',
		gap: "10em",
		breakpoints: {
			980: {
				focus: "center",
			},
		},
	}).mount();
}

//make all pagination and arrows go away if there is only one element.
const carousels = document.querySelectorAll('.splide');

carousels.forEach(car => {
	const slides = car.querySelectorAll('.splide__slide');

	console.log(slides);

	if (slides.length < 2) {
		car.querySelector('.splide__arrows').style.display = "none";
	}
})


